module.exports = __webpack_public_path__ + "static/media/GeraltofRivia.c389d5a4.jpg";